var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningRed2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AA1E1E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1176.1,1022.2L652.2,114.7c-10.8-18.7-30.8-30.2-52.4-30.2s-41.6,11.5-52.4,30.2L23.5,1022.2 c-10.8,18.7-10.8,41.8,0,60.5c10.8,18.7,30.8,30.2,52.4,30.2h1047.9c21.6,0,41.6-11.5,52.4-30.2 C1186.9,1063.9,1186.9,1040.9,1176.1,1022.2z M180.7,991.9l419.1-726l419.1,726H180.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M642.7,836.1c-11.5-10.2-25.7-15.3-42.9-15.3c-17.1,0-31.4,5.1-42.9,15.3c-11.5,10.2-17.2,23.2-17.2,39 c0,15.8,5.7,28.8,17.2,39c11.4,10.2,25.7,15.3,42.9,15.3c17.1,0,31.4-5.1,42.9-15.3c11.4-10.2,17.2-23.2,17.2-39 C659.8,859.2,654.1,846.2,642.7,836.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "556.8,775.6 644.4,775.6 658.2,456.1 543,456.1  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed2);
export default __webpack_public_path__ + "static/media/warning-red-2.7a15798ae01d348a04ce90baa230d606.svg";
export { ForwardRef as ReactComponent };